import React from "react";

import { makeStyles, createStyles, ITheme } from "@chainsafe/common-theme";
import CustomDrawer from "../Components/Custom/CustomDrawer";
import { Typography } from "../lib/common-components";
import { Button } from "../Components/Custom/Button";
import { useWeb3 } from "../lib/web3-context";
import { ChilizConfigProvider } from '../config/configProvider'

const useStyles = makeStyles(({ constants, zIndex }: ITheme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      maxWidth: "600px",
      width: "initial !important",
      zIndex: zIndex?.layer3,
    },
    content: {
      margin: 'auto 0',

      "& h1": {
        color: "#610287",
        fontWeight: 800,
        fontSize: '40px',
        lineHeight: '42px',
        marginBottom: '32px'
      },

      "& p": {
        fontSize: "16px",
        lineHeight: "24px",
        marginBottom: "60px"
      }
    },
    buttons: {
      marginTop: "50px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      "& *": {
        marginRight: constants.generalUnit,
        textDecoration: "none",
      },
      "& button": {
        flex: 0.4
      }
    },
    paragraph: {
      margin: `${constants.generalUnit * 3}px 0`,
    },
    addCC2Button: {
      cursor: "pointer",
      color: "#FF0051"
    }
  })
);

interface IChangeNetworkDrawerProps {
  open: boolean;
  close: () => void;
}

const ChangeNetworkDrawer: React.FC<IChangeNetworkDrawerProps> = ({
  open,
  close,
}) => {
  const classes = useStyles();

  const { wallet } = useWeb3()

  const onAddCC2Click = async() => {
    const config = new ChilizConfigProvider()
    let chainDetails = config.getDefaultChainDetails()
    wallet?.provider.request({
      method: 'wallet_addEthereumChain',
      params: [{
        chainId: `0x${Number(chainDetails.networkId).toString(16)}`,
        chainName: chainDetails.name,
        nativeCurrency: chainDetails.chainNativeCurrency,
        rpcUrls: [chainDetails.rpcUrl],
        blockExplorerUrls: [chainDetails.blockExplorer],
      }],
    })
  }

  return (
    <CustomDrawer open={open} className={classes.root}>
      <div className={classes.content}>
        <Typography variant="h1" component="h1">
          Changing Networks
        </Typography>
        <Typography className={classes.paragraph} component="p">
          To change networks, please open your browser wallet and change networks
          there.
          <br/>
          <br/>
          Don’t have Chiliz Chain in your Meta mask? <Typography className={classes.addCC2Button} onClick={onAddCC2Click}>Click here to add it now!</Typography>
          <br />
          <br/>
          Note: your transfer settings will be reset.
        </Typography>
        <section className={classes.buttons}>
          <Button onClick={() => close()} variant="primary" size="large">
            OK
          </Button>
        </section>
      </div>
    </CustomDrawer>
  );
};

export default ChangeNetworkDrawer;
